import React from 'react';
import type { ViewProps } from 'react-native';
import { Form, LoadingPlaceholder } from '@sweetgreen/garnish';

// ────────────────────────────────────────────────────────────────────────────────

export const JoinVerificationScreenLoading = ({
  testID,
}: JoinVerificationScreenLoadingProps) => (
  <Form.Container testID={testID}>
    <LoadingPlaceholder
      rows={5}
      rowHeight={[100, 60, 70, 70, 80]}
      palette="cream"
    />
  </Form.Container>
);

// ─── TYPES ──────────────────────────────────────────────────────────────────────

type JoinVerificationScreenLoadingProps = Pick<ViewProps, 'testID'>;
